import React from 'react';
import ClassAssembly  from 'views/ClassAssembly6D';

const ClassAssemblyPage = () => {
    return <ClassAssembly />;
  };
  
  export default ClassAssemblyPage;